// Components that are only used on the videos tab (and related pages.)
// Please keep the lines sorted to avoid merge conflicts.
import { defineAsyncComponent } from "vue";

export const Filmmaker = defineAsyncComponent(async () => (await import("./static/Videos")).Filmmaker);
export const UserUploadedVideos = defineAsyncComponent(async () => (await import("./static/Videos")).UserUploadedVideos);
export const Video = defineAsyncComponent(async () => (await import("./static/Videos")).Video);
export const VideoBarDetailed = defineAsyncComponent(async () => (await import("./static/Videos")).VideoBarDetailed);
export const VideoRoot = defineAsyncComponent(async () => (await import("./static/Videos")).VideoRoot);
export const VideoWatchHeading = defineAsyncComponent(async () => (await import("./static/Videos")).VideoWatchHeading);
export const VimeoUploadForm = defineAsyncComponent(async () => (await import("./static/Videos")).VimeoUploadForm);
